import { FC } from 'react'
import styles from './settingsNav.module.scss'

interface SettingsNavProps {
  activeTab: string
  onTabChange: (tab: string) => void
  tabs: { name: string }[]
}

const SettingsNav: FC<SettingsNavProps> = ({
  activeTab,
  onTabChange,
  tabs,
}) => {
  return (
    <div className={styles.tabsSection}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <button
            className={`${styles.tab} ${activeTab === tab.name ? styles.tabActive : ''}`}
            data-label={tab.name}
            key={tab.name}
            onClick={() => onTabChange(tab.name)}
            type="button"
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  )
}

export default SettingsNav
